import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/escape-marketing-agency-contracts-colorado")!;

export const Route = createFileRoute("/learn/escape-marketing-agency-contracts-colorado")({
  head: () => seoHead("/learn/escape-marketing-agency-contracts-colorado", "Marketing Agency Contracts: A Colorado Owner's Guide", "How to spot 90-day, 6-month, and annual marketing lock-ins, what to ask before you sign, and why month-to-month flat rates protect Colorado businesses.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
